import { marketingCmsClient } from './contentful-client';
import type { FormOutageNotice } from 'src/contexts';

// Publishing this entry turns the notice on; unpublishing turns it off.
export const FORM_OUTAGE_NOTICE_ENTRY_ID = '2OLqWmw6LrLmRVTFgPPdFH';

/**
 * Alternative: Fetch by specific entry ID
 * Use this version if you want to hardcode a specific entry ID
 */
export async function fetchFormOutageNoticeById(
  entryId: string,
): Promise<FormOutageNotice | null> {
  try {
    const entry = await marketingCmsClient.getEntry(entryId);
    const fields = entry.fields as any;

    return {
      status: fields.status,
      title: fields.title,
      description: fields.description,
    };
  } catch (error) {
    // eslint-disable-next-line no-console
    // console.error('Error fetching form outage notice:', error);
    return null;
  }
}
